import { FC } from 'react';
import styles from './MenuChoiceCustomizations.module.scss';

export const FormControl: FC<{
  label: string;
  rightComponent?: any;
  children?: React.ReactNode;
}> = ({ label, rightComponent, children }) => {
  return (
    <div className={styles.ff_formControlContainer}>
      <div className={styles.ff_formControlLabel}>
        <span>{label}</span>
        {rightComponent}
      </div>
      {children}
    </div>
  );
};
